module.exports = __webpack_public_path__ + "static/media/03.0a3e50f4.jpg";